import { render, staticRenderFns } from "./CaretDownIcon.vue?vue&type=template&id=6e6e8764&"
import script from "./CaretDownIcon.vue?vue&type=script&lang=js&"
export * from "./CaretDownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports